<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h5>
                Meetings
            </h5>
        </div>

        <loading-spinner v-if="loading"/>

        <ul v-else class="list-group">
            <li v-for="meeting in meetings.data" class="list-group-item">
                <div style="display: flex; align-items: center">
                    <div style="flex-grow: 1">
                        {{ meeting.attributes.user_full_name }}

                        <br>

                        <span class="text-muted">
                            {{
                                meeting.attributes.category | verboseCategory
                            }} &middot; {{ meeting.attributes.is_new_business ? 'New Business' : 'More Business' }}
                        </span>
                    </div>

                    <div class="text-right">
                        {{ meeting.attributes.starts_at | datetime }} - {{ meeting.attributes.ends_at | time }}

                        <br>

                        <span v-if="meeting.attributes.held_at" class="label label-success">
                            Held
                        </span>

                        <span v-else class="label label-info">
                            Booked
                        </span>
                    </div>

                    <div>
                        <div class="btn-group" style="margin-left: 15px">
                            <div class="dropdown" style="display: inline">
                                <button
                                    class="btn btn-white dropdown-toggle"
                                    type="button"
                                    data-toggle="dropdown"
                                >
                                    <i class="fa fa-check"/>
                                </button>

                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link
                                            :to="'/companies/' + meeting.attributes.company_id + '/opportunities/create?meeting_id=' + meeting.id"
                                        >
                                            Create opportunity
                                        </router-link>

                                        <a href="#" @click.prevent="hold(meeting)">
                                            Mark as held
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>

            <li v-if="meetings.data.length && meetings.meta.last_page > 1" class="list-group-item">
                <resource-pager :pagination="meetings.meta" @navigate="navigate"/>
            </li>

            <li v-if="!meetings.data.length" class="list-group-item text-center">
                <i>
                    No meetings have been registered for this company.
                </i>
            </li>
        </ul>
    </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import notify from '@/notify'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'

export default {
    components: {LoadingSpinner, ResourcePager},

    props: {
        company: {
            required: true
        }
    },

    data() {
        return {
            meetings: null,

            page: 1,

            editing: null,

            loading: true
        }
    },

    mounted() {
        this.load()
    },

    methods: {
        load() {
            http.get('/api/v2/meetings', {
                page_size: 5,
                page: this.page,
                'filter[company_id]': this.company.id,
                sort: '-starts_at'
            })
                .then(response => {
                    this.meetings = response.data

                    this.loading = false
                })
        },

        hold(meeting) {
            modal.confirm('Are you sure that you want to mark the meeting as held?', () => {
                http.post('/api/v2/held-meetings', {meeting_id: meeting.id})
                    .then(response => {
                        notify.success('The meeting was marked as held')

                        this.update(response.data.data)
                    })
                    .catch(error => {
                        if (error.response.status === 400) {
                            return notify.error(error.response.data.message)
                        }

                        throw error
                    })
            })
        },

        edit(meeting) {
            this.editing = meeting

            $('#edit-meeting-modal').modal('show')
        },

        update(meeting) {
            this.meetings.data.splice(
                this.meetings.data.findIndex(existing => existing.id === meeting.id),
                1,
                meeting
            )
        },

        navigate(page) {
            this.page = page

            this.load()
        }
    },

    filters: {
        verboseCategory(value) {
            if (value === 'online') {
                return 'Online'
            }

            if (value === 'physical') {
                return 'Physical'
            }
        }
    }
}
</script>
